import { useContext, useMemo } from 'react';
import { FileUploadStatus } from '@trinity/chat';
import { FileUploadsStateContext } from '@trinity/chat-components/containers/WorkspaceFileUpload/Context.js';

export const useUploadInProgress = () => {
  const state = useContext(FileUploadsStateContext);

  const inProgress = useMemo(() =>
    state.valid.some(s => [FileUploadStatus.InProgress, FileUploadStatus.Enqueued].includes(s.status))
    , [state.valid],
  );

  return inProgress;
};

export default useUploadInProgress;